import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_ENDPOINTS } from '../config';

export default function Home() {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    async function fetchFeaturedProducts() {
      try {
        const response = await axios.get(API_ENDPOINTS.products);
        // Get first 3 products as featured
        setFeaturedProducts(response.data.slice(0, 3));
      } catch (error) {
        setError('Failed to fetch featured products');
        console.error('Error fetching featured products:', error);
      } finally {
        setLoading(false);
      }
    }

    fetchFeaturedProducts();
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-[#0f2027] via-[#2c5364] to-[#24243e] min-h-[60vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 opacity-40 bg-[url('https://images.unsplash.com/photo-1542751371-adc38448a05e?ixlib=rb-1.2.1&auto=format&fit=crop&w=2850&q=80')] bg-cover bg-center"></div>
        <div className="relative z-10 text-center max-w-2xl mx-auto px-4 py-24">
          <h1 className="text-5xl sm:text-6xl font-extrabold tracking-tight text-white drop-shadow-lg mb-4">
            Welcome to <span className="text-[#00ffe7]">NexGENGaming</span>
          </h1>
          <p className="mt-4 text-xl text-gray-200 max-w-2xl mx-auto font-medium drop-shadow">
            Level up your experience with the latest gaming consoles, accessories, and more. <br />
            <span className="text-[#00ffe7] font-bold">Unleash the Next Generation of Play.</span>
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/products"
              className="inline-block bg-[#00ffe7] text-gray-900 px-10 py-3 rounded-lg text-lg font-bold shadow-lg hover:bg-[#00bfae] transition-colors duration-200 border-2 border-transparent hover:border-[#00ffe7]"
            >
              Shop Now
            </Link>
            <a
              href="#featured"
              className="inline-block bg-transparent border-2 border-[#00ffe7] text-[#00ffe7] px-10 py-3 rounded-lg text-lg font-bold hover:bg-[#00ffe7] hover:text-gray-900 transition-colors duration-200"
            >
              See Featured
            </a>
          </div>
        </div>
      </div>

      {/* Featured Products Section */}
      <div id="featured" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="text-4xl font-extrabold tracking-tight text-gray-900 text-center mb-10">
          Featured Products
        </h2>

        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00ffe7]"></div>
          </div>
        ) : error ? (
          <div className="text-center text-red-500 mt-8">
            {error}
          </div>
        ) : (
          <div className="mt-8 grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-3">
            {featuredProducts.map((product) => (
              <Link
                key={product._id}
                to={`/products/${product._id}`}
                className="group bg-white rounded-2xl shadow-xl hover:shadow-2xl transition-shadow duration-300 overflow-hidden border-2 border-transparent hover:border-[#00ffe7]"
              >
                <div className="w-full aspect-w-1 aspect-h-1 bg-gray-200 rounded-t-2xl overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-56 object-center object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{product.name}</h3>
                  <p className="text-gray-600 mb-4 min-h-[48px]">{product.description}</p>
                  <div className="mt-2">
                    <span className="text-[#00bfae] font-extrabold text-2xl">
                      ₹{product.variants[0]?.price?.toLocaleString('en-IN') || 'N/A'}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}

        <div className="mt-16 text-center">
          <Link
            to="/products"
            className="inline-block bg-[#00ffe7] text-gray-900 px-10 py-3 rounded-lg text-lg font-bold shadow-lg hover:bg-[#00bfae] transition-colors duration-200 border-2 border-transparent hover:border-[#00ffe7]"
          >
            View All Products
          </Link>
        </div>
      </div>
    </div>
  );
} 